export enum ShippingPolicy {
  Company = 'company',
  Clinic = 'clinic',
  Home = 'home',
}

export const shippingPolicyEnumValues: string[] = Object.values(ShippingPolicy)
